import { queryOptions } from "@tanstack/react-query";
import { apiUrl } from "@/lib/api-url";

export interface AvailableTopic {
  tag: string;
  label: string;
  count: number;
}

export interface AvailableTopicsEnvelope {
  topics: AvailableTopic[];
}

/**
 * SSR-safe public query for the hero theme carousel: the problem tags active
 * therapists actually offer. apiUrl() resolves to loopback server-side (a bare
 * relative fetch throws under Bun); stable key for invalidation matching
 * (see invalidatePagesUsing).
 */
export const availableTopicsQuery = queryOptions({
  queryKey: ["available-topics", "public"] as const,
  queryFn: async (): Promise<AvailableTopicsEnvelope> => {
    const res = await fetch(apiUrl("/api/available-topics"));
    if (!res.ok) throw new Error("Failed to fetch available topics");
    return res.json();
  },
});
